import axios from 'axios'
import { orderBy } from 'lodash'
import {API_ADMIN} from '@/utils/constants/Api'
import {ChannelModel} from '@/channel/models/ChannelModel'
import { ChannelEnum, EntityEnum } from '@c2b/muven-commons'
import { ChannelSettingsFormModel } from '../models/ChannelSettingsFormModel'
import { ChannelCreationModel } from '../models/ChannelCreationModel'
import subscriberManager from '@/subscriber/managers/SubscriberManager'

interface Credentials {
    [key:string]: any;
}

interface CredentialsSchema {
    [key:string]: any;
}

interface CustomChannelUser {
    username: string;
    password: string;
}

interface PostmanEnviromentData {
    [key:string]: any;
}

export default {
    getChannels():Promise<ChannelModel[]> {
        return axios.get(`${API_ADMIN}channels`)
            .then(({data}) => {
                const channelList = data.map((c:ChannelModel) => new ChannelModel(c));
                const channelListOrdered = orderBy(channelList, ['name'], ['asc']);
                const channelListOrderedByBoolean = [
                    ...channelListOrdered.filter((c:ChannelModel) => c.isActive === true),
                    ...channelListOrdered.filter((c:ChannelModel) => c.isActive === false),
                ];

                return channelListOrderedByBoolean
            })
    },
    getChannelById(id:number):Promise<ChannelModel> {
        return axios.get(`${API_ADMIN}channels/${id}`)
            .then(({data}) => {
                return new ChannelModel(data)
            })
    },
    createChannel(channelCreation: ChannelCreationModel): Promise<ChannelModel> {
        return axios.post(`${API_ADMIN}channels`, channelCreation)
            .then(({data}) => {
                return new ChannelModel(data);
            })
    },
    getCredentials(id:number):Promise<Credentials> {
        return axios.get(`${API_ADMIN}channels/${id}/credentials`)
            .then(({data}) => {
                return data
            })
    },
    getCredentialsByStore(idChannel:number, idStore:number):Promise<Credentials> {
        return axios.get(`${API_ADMIN}channels/${idChannel}/credentials/stores/${idStore}`)
            .then(({data}) => {
                return data
            })
    },
    getCredentialsSchema(id:number):Promise<CredentialsSchema> {
        return axios.get(`${API_ADMIN}channels/${id}/credentials_schema`)
            .then(({data}) => {
                return data
            })
    },
    saveCredentials(id:number, credentials:Credentials):Promise<Credentials> {
        return axios.post(`${API_ADMIN}channels/${id}/credentials`, credentials)
            .then(({data}) => {
                return data
            })
    },
    saveCredentialsByStore(idChannel:number, idStore:number, credentials:Credentials):Promise<Credentials> {
        return axios.post(`${API_ADMIN}channels/${idChannel}/credentials/stores/${idStore}`, credentials)
            .then(({data}) => {
                return data
            })
    },
    pollShopifyAuth(shop: string): Promise<{ ready: boolean; code?: string }> {
        return axios.get(`/public/admin-rest-api/channels/shopify_auth_poll/${encodeURIComponent(shop)}`)
            .then(({ data }) => data)
    },
    pollTiktokShopAuth(state: string): Promise<{ ready: boolean; code?: string; state?: string; shopRegion?: string }> {
        return axios.get(`/public/admin-rest-api/channels/tiktok_auth_poll/${encodeURIComponent(state)}`)
            .then(({ data }) => data)
    },
    getAuthorizationUrl(channelEnum: ChannelEnum, shop?: string):Promise<any> {
        const params = shop ? `?shop=${encodeURIComponent(shop)}` : ''
        return axios.get(`${API_ADMIN}channels/${channelEnum}/authorization_url${params}`)
            .then(({data}) => {
                return data
            })
    },
    getAuthenticationTokens(channelId: number, credentials: Credentials):Promise<any> {
        return axios.post(`${API_ADMIN}channels/${channelId}/authentication_tokens`, credentials)
            .then(({data}) => {
                return data
            })
    },
    getSellerInfo(channelId: number, credentials: Credentials):Promise<any> {
        return axios.post(`${API_ADMIN}channels/${channelId}/seller_info`, credentials)
            .then(({data}) => {
                return data
            })
    },
    syncEntityList(channelId: number, entityList: EntityEnum[]):Promise<any> {
        return axios.post(`${API_ADMIN}channels/${channelId}/synchronization`, entityList)
            .then(({data}) => {
                return data
            })
    },
    pingChannel(channelEnum: ChannelEnum, credentials:Credentials, idChannel?: number):Promise<any> {
        const url = `${API_ADMIN}channels/${channelEnum}/ping`;
        // Agentes que guardam tokens no próprio config (ex.: TikTok Shop) precisam do idChannel para localizá-los
        const body = idChannel ? { ...credentials, idChannel } : credentials;
        return axios.post(url, body)
    },
    updateSettings(channelId: number, channelSettings:ChannelSettingsFormModel):Promise<any> {
        return axios.put(`${API_ADMIN}channels/${channelId}`, channelSettings)
            .then(({data}) => {
                return data
            })
    },
    updatePriceManagementStore(idChannel: number, idStore: number):Promise<void> {
        return axios.put(`${API_ADMIN}channels/${idChannel}/update_price_management_store/${idStore}`)
            .then(({data}) => {
                return data
            })
    },
    getPostmanEnviromentData(channelId:number):Promise<PostmanEnviromentData> {
        return axios.get(`${API_ADMIN}channels/${channelId}/custom_channel/postman_enviroment`)
            .then(({data}) => data)
    },
    createOrUpdateCustomChannelUser(channelId:number):Promise<CustomChannelUser> {
        return axios.post(`${API_ADMIN}channels/${channelId}/custom_channel/users/create_update`)
            .then(({data}) => data)
    },

    deleteChannel(id:number):Promise<void> {
        return axios.delete(`${API_ADMIN}channels/${id}`)
    }
}
